import React, { memo, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import store from "stores/interfaces";

import PanelList from "../PanelList";
import FloatWindow from "components/FloatWindow";

import { useTranslation } from "react-i18next";

const PanelListDrawer = () => {
  const d = useAppDispatch();
  const [t] = useTranslation();
  const open = useAppSelector(
    (state) => store.getAppState(state, "openRoomControlWindows").panel.open
  );
  // const width = useAppSelector(store.getMenuWidth);
  const onClose = useCallback(() => {
    d(
      store.appStateMutate((state) => {
        state.openRoomControlWindows.panel.open = false;
        state.openRoomControls = null;
      })
    );
  }, [d]);
  const onAdd = useCallback(() => {
    d(
      store.appStateMutate((state) => {
        state.openRoomImageSelect = true;
        state.openRoomImageSelectDir = "item";
        state.openRoomImageSelectTarget = "item/new";
      })
    );
  }, [d]);
  return (
    <FloatWindow
      onClose={onClose}
      onAdd={onAdd}
      open={open}
      title={t("スクリーンパネル一覧")}
    >
      <PanelList />
    </FloatWindow>
  );
};

export default memo(PanelListDrawer);
